const enComponents = {
  headerCpn_Bookmarks: 'Bookmarks',
  headerCpn_SeeAllHotels: 'See all hotels',
  headerCpn_BookingHistory: 'Booking history',
  headerCpn_SeeAllBooking: 'See all booking',
  headerCpn_AgentPortal: 'Agent Portal',
  headerCpn_ChangePassword: 'Change password',
  headerCpn_Profile: 'Profile',
  footerCpn_Privacy: 'Privacy Policy',
  footerCpn_Terms: 'Terms & Condition',
  footerCpn_SiteMap: 'Site Map',
  homeCpn_PickOfTheWeek: 'Pick of the week',
  homeCpn_PopularHotels: 'Popular Hotels',
  //   headerCpn_: '',
  //   headerCpn_: '',
  //   headerCpn_: '',
  //   headerCpn_: '',
  //   headerCpn_: '',
  //   headerCpn_: '',
  //   headerCpn_: '',
};
export default enComponents;
